module.exports = __webpack_public_path__ + "assets/img/media_10.1885ed91.png";